import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router";
import Header from "./Header";
import Footer from "../Footer";
import fire from "./Firebase";
import "../App.css";

function CertificateTemp6() {
  document.title = "HR School-Template 4";
  const [temp6, settemp6] = useState({});
  const conponentPDF = useRef();
  useEffect(() => {
    fire.child("certificates").on("value", (data) => {
      if (data.val() == null || data.val() == "") alert("Data Fetch");
      else {
        settemp6(data.val());
      }
      console.log(data.val());
    });
  }, []);
  const navigate = useNavigate();
  function generatePDF(keys) {
    sessionStorage.setItem("lastname6", keys);
    navigate("/try6");
  }

  return (
    <div>
      <Header />
      <center>
        {" "}
        <h1>Download PDF Certificate</h1>
      </center>
      <div id="maindiv" ref={conponentPDF}>
        {Object.keys(temp6).map((all, index) => {
          return (
            <>
              <div id="certificatetemp6" style={{textTransform:"uppercase"}}>
                <div>
                  <div
                    // style={{
                    //   height: "100%",
                    //   width: "100%",
                    //   padding: "10px",
                    //   backgroundColor: "lightseagreen",
                    // }}
                  >
                    <div>
                      <div>
                        <div className="cert-logo">
                          <div className="cert-logo-name">
                            HR School
                            <br />
                          </div>
                        </div>
                      </div>
                      <div className="cert-title">
                        CERTIFICATE OF COMPLETION
                      </div>
                      <div className="cert-no">
                        CERTIFIED {temp6[all].Field} SPECIALIST
                      </div>
                      <div className="cert-content">
                        <div className="cert-label">
                          THIS IS TO CERTIFY THAT
                        </div>{" "}
                        <br />
                        <div className="cert-user">
                          <div className="cert-user-name">
                            NAME :- {temp6[all].Gender} {temp6[all].Name}
                          </div>{" "}
                          <br />
                          <div className="cert-user-info">
                            FATHER NAME :- {temp6[all].Father}
                          </div>{" "}
                          <br />
                          <div className="cert-user-info">
                            COURSE DURATION :- {temp6[all].Course} MONTHS
                          </div>{" "}
                          <br />
                          <div className="cert-user-info">
                            COURSE NAME :- {temp6[all].Coursename}
                          </div>{" "}
                          <br />
                        </div>
                        <div className="cert-achievement">
                          THE BEAUTIFUL THING ABOUT LEARNING IS THAT NO ONE CAN
                          TAKE IT AWAY FROM YOU.
                        </div>{" "}
                        <br />
                        <br />
                        <div className="cert-signature">
                          <div>
                            HAS SUCCESSFULLY COMPLETED THE{" "}
                            {temp6[all].Coursename} COURSE WITH HR SCHOOL
                          </div>{" "}
                          <br />
                          <div className="cert-signature-sign"></div>
                          <div>
                            <div style={{ fontWeight: "bold" }}>
                              WITH SCORE OF {temp6[all].grade}
                            </div>{" "}
                            <br />
                            <div style={{ fontWeight: "bold" }}>Dated</div> <br />
                          </div>
                          <div>START DATE :- {temp6[all].startdate}/{temp6[all].startmonth}/{temp6[all].startyear}</div>
                          <br />
                          <div>END DATE :-{temp6[all].enddate}/{temp6[all].endmonth}/{temp6[all].endyear}</div>
                        </div>
                      </div>

                      <div style={{textAlign:"center"}}>www.hrschool.com</div>
                    </div>
                  </div>
                </div>
              </div>
              <center>
                      {" "}
                      <br />
                      <button onClick={() => generatePDF(all)}>
                      Download {temp6[all].Name} Image
                      </button>
                    </center>
            </>
          );
        })}
      </div>
    </div>
  );
}

export default CertificateTemp6;
